import { defineMessages } from 'react-intl';

export const messages: {
	moreButtonLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	moreButtonLabel: {
		id: 'company-hub.links-menu-extension.config-panel.property-config.more-button-label',
		defaultMessage: 'More',
		description: 'Opens a dialog to show options for the selected item',
	},
});
